export default __webpack_public_path__ + "static/data-vis-categorical-dont-8015ee2291c2cd889f957977b2ac1bf6a264d61d4a16c107f494893e59c1f33b.png";